var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5C0 19.1274 5.37258 24.5 12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6047 12.5013L17.6639 9.86134L16.8191 8.27734L12.1823 10.1205C12.0767 10.1685 11.9231 10.1685 11.8175 10.1205L7.18074 8.27734L6.33594 9.86134L11.3951 12.5013L6.33594 15.1413L7.18074 16.7253L11.8175 14.8821C11.9231 14.8341 12.0767 14.8341 12.1823 14.8821L16.8191 16.7253L17.6639 15.1413L12.6047 12.5013Z",
    fill: "#23F7DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgld);
export default __webpack_public_path__ + "static/media/egld.06826ce7649c5cf276a5526fa1f414b4.svg";
export { ForwardRef as ReactComponent };